export default "__VITE_ASSET__bsPJaGg9__"